import { render, staticRenderFns } from "./SearchSection.vue?vue&type=template&id=382be833&scoped=true&"
import script from "./SearchSection.vue?vue&type=script&lang=ts&"
export * from "./SearchSection.vue?vue&type=script&lang=ts&"
import style0 from "./SearchSection.vue?vue&type=style&index=0&id=382be833&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382be833",
  null
  
)

export default component.exports